// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const workflowTypeSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
  },
  {
    key: 'refId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'refId',
  },
  {
    key: 'companyId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'companyId',
  },
  {
    key: 'name',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'name',
  },
  {
    key: 'description',
    type: 'string',
    required: false,
    component: 'Textarea',
    fullPath: 'description',
  },
  {
    key: 'version',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'version',
    numberFormat: 'integer',
  },
  {
    key: 'versionStatus',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'versionStatus',
    options: ['active', 'draft', 'deprecated'],
  },
  {
    key: 'steps',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'steps',
    nested: [
      {
        key: '0',
        type: 'string',
        required: true,
        component: 'TextInput',
        fullPath: 'steps[0]',
      },
    ],
  },
  {
    key: 'approvalConditions',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'approvalConditions',
    nested: [
      {
        key: '0',
        type: 'object',
        required: true,
        component: 'TextInput',
        fullPath: 'approvalConditions[0]',
        nested: [
          {
            key: 'stepTypeRefId',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'approvalConditions[0].stepTypeRefId',
          },
          {
            key: 'stepStatus',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'approvalConditions[0].stepStatus',
            options: ['due', 'approved', 'rejected', 'skipped'],
          },
        ],
      },
    ],
  },
  {
    key: 'createdBy',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdBy',
  },
  {
    key: 'updatedBy',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedBy',
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(workflowTypeSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(workflowTypeSchema)
}
